import Api from '@/misc/api'
import type { Commit } from '@/misc/types'
import type { GroupageSimulationRequestDto, GroupageSimulationResponseDto } from '@/stay-list/stay-quick-view/store/dto'

// Routed through Api.post (like prefetchMcoStaySuggestions) so errors/401s are handled the same way.
export function simulateGroupage(stayId: number, request: GroupageSimulationRequestDto, commit: Commit): Promise<GroupageSimulationResponseDto[]> {
  return new Promise((resolve, reject) => {
    Api.post(
      {
        url: `/api/mco/stays/${stayId}/groupage-simulation`,
        body: request,
        successMut: (data: GroupageSimulationResponseDto[]) => resolve(data),
        errorMut: () => reject(new Error(`Failed to simulate groupage (stay ${stayId})`)),
      },
      commit
    )
  })
}
